<template>
	<page>
		<module title="分销设置">
			<c-form ref="form">
				<c-form-item type="image" label="分销海报图" name="share_img_list" limit="5" required file-word="建议尺寸：600×1000像素，格式支持：jpg、png，最多上传5张"></c-form-item>
				<c-form-item label="分销奖励">
					<ul class="tab flex">
						<li v-for="(item, i) in levelList" :key="i" :class="{'z-crt': currentTab == i}" @click="currentTab = i">{{item.level_name}}</li>
					</ul>
					<div v-for="(item, i) in levelList" :key="i" v-show="currentTab == i" class="tab-content">
						<c-form style="padding: 30px 24px;">
							<c-form title="推荐奖励设置">
								<c-form-item v-model="item.is_directly_reward" type="radio" label="直推奖励" :options="directOptions" word="会员用户直接推荐会员用户可获得『直推奖励』"></c-form-item>
								<c-form-item v-show="item.is_directly_reward == 2">
									<c-table v-model="item.directly_reward_list" border height="auto" style="width: 600px;">
										<c-table-column
											label="直推等级"
											name="recommend_level_name"
										></c-table-column>
										<c-table-column
											label="奖励金额 (元)"
										>
											<template v-slot="{data}">
												<c-input v-model="data.reward_money" word="元"></c-input>
											</template>
										</c-table-column>
									</c-table>
								</c-form-item>
								<c-form-item v-model="item.is_indirect_reward" type="radio" label="间推奖励" :options="indirectOptions" word="会员用户间接推荐会员用户可获得『间推奖励』" v-show="false"></c-form-item>
								<c-form-item v-show="item.is_indirect_reward == 2">
									<c-table v-model="item.indirect_reward_list" border height="auto" style="width: 600px;">
										<c-table-column
											label="间推等级"
											name="recommend_level_name"
										></c-table-column>
										<c-table-column
											label="奖励金额 (元)"
										>
											<template v-slot="{data}">
												<c-input v-model="data.reward_money" word="元"></c-input>
											</template>
										</c-table-column>
									</c-table>
								</c-form-item>
							</c-form>
							<c-form title="价差返佣设置">
								<c-form-item v-model="item.is_price_difference" type="radio" label="价差返佣" :options="commisionOptions" :inline-word="false" disabled>
									<div slot="word">
										<p>下级普通用户在商城下单，上级经销商根据购买产品对应的经销商价格享受『价差返佣』。</p>
										<p>例：A普通用户，报价为100，B是A的上级(VIP)，报价为60，当A在商城下单后，这中间的20元差价将全额奖励给B用户。</p>
									</div>
								</c-form-item>
							</c-form>
							<c-form title="平级下单奖励设置" v-if="item.id == 4" ref="pjConfigForm">
								<c-form-item type="number" label="直推奖励" :limit="[0,20]" required name="zt_pz_order_ratio" decimal="2" input-unit="%" :inline-word="false" word="直推的总代如果向平台下单将获得对应的交易额相应比例的额外积分奖励">
								</c-form-item>
								<c-form-item type="number" label="间推奖励" :limit="[0,20]" required name="jt_pz_order_ratio" decimal="2" input-unit="%" :inline-word="false" word="间推的总代如果向平台下单将获得对应的交易额相应比例的额外积分奖励">
								</c-form-item>
							</c-form>
						</c-form>
					</div>
				</c-form-item>
			</c-form>

			<template slot="button">
				<c-button size="m" @click="saveHandle()">提交保存</c-button>
			</template>
		</module>
	</page>
</template>

<script>
	import validate from '@/assets/script/validate.js'
	
	export default {
		name: 'm_share',
		
		data() {
			return {
				levelList: [],
				currentTab: 0,
				
				directOptions: [{
					name: '开启',
					value: 2
				}, {
					name: '关闭',
					value: 1
				}],
				
				indirectOptions: [{
					name: '开启',
					value: 2
				}, {
					name: '关闭',
					value: 1
				}],
				
				commisionOptions: [{
					name: '开启',
					value: 2
				}, {
					name: '关闭',
					value: 1
				}]
			}
		},
		
		mounted() {
			this.request({
				url: '/share/config/detail',
				success: data => {
					data.zt_pz_order_ratio = parseFloat(parseFloat(data.zt_pz_order_ratio*100).toFixed(2));
					data.jt_pz_order_ratio = parseFloat(parseFloat(data.jt_pz_order_ratio*100).toFixed(2));
					this.$refs.form.set(data);
					this.levelList = data.level_list;
					
					this.$nextTick(()=>{
						this.$refs.pjConfigForm[0].set(data);
					})
				}
			});
		},

		methods: {
			saveHandle() {
				this.$refs.form.submit({
					url: '/share/config/edit',
					rule: {
						share_img_list: '请上传分销海报图',
						zt_pz_order_ratio: '请设置总代直推平级下单奖励',
						jt_pz_order_ratio: '请设置总代直推平级下单奖励'
					},
					dataFormatter: data => {
						data.level_list = this.levelList;
						data.zt_pz_order_ratio = ""+(parseFloat(data.zt_pz_order_ratio)/100);
						data.jt_pz_order_ratio = ""+(parseFloat(data.jt_pz_order_ratio)/100);
						return data;
					},
					success: () => {
						this.$message({
							text: '保存成功'
						});
					}
				})
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.tab {
		margin-bottom: -1px;

		li {
			width: 100px;
			border: 1px solid #ddd;
			padding: 0 10px;
			margin-right: -1px;
			line-height: 40px;
			font-size: 13px;
			text-align: center;
			color: #000;
			background: #fff;
			cursor: pointer;

			&:hover {
				position: relative;
			theme-border(lesser);
			theme-color(lesser);
			}

			&.z-crt {
				position: relative;
			theme-border(lesser);
				color: #fff;
			theme-background(lesser);
			}
		}
		
		&-content {
			border: 1px solid #ddd;
		}
	}
</style>